import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_dp_list } from "../../redux/dplistSlice";

const DPList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const { dp_list, total_dp_count } = useSelector((state) => state.dplist);

  useEffect(() => {
    store.dispatch(get_dp_list({ page: page, rows: rows }));
  }, []);
  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 || store.dispatch(get_dp_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_dp_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_dp_count || setpage(page + 1);
    rows * page >= total_dp_count ||
      store.dispatch(get_dp_list({ page: page + 1, rows: rows }));
  };
  return (
    <>
  <Card
  bg="#fff"
  paddingInline={5}
  paddingBlock={2}
  flexDirection={["column", "row"]}
  alignItems={["flex-start", "center"]}
  gap={3}
  flexWrap="wrap"
>
  <Heading fontSize="xl">DP List</Heading>

  <Spacer display={["none", "block"]} /> {/* Spacer for desktop, hidden on mobile */}

  <Flex alignItems="center" gap={2} w={["100%", "auto"]}>
    <Select
      placeholder=""
      size="md"
      value={rows}
      onChange={(e) => {
        store.dispatch(get_dp_list({ page: page, rows: e.target.value }));
        setRows(e.target.value);
      }}
      w={["100%", "80px"]}  // Full width on mobile, compact on larger screens
    >
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </Select>
  </Flex>

  <InputGroup
    bg="#f4f5f7"
    borderRadius={5}
    maxW="sm"
    w={["100%", "auto"]}
  >
    <Input placeholder="Search..." />
    <InputRightElement>
      <FiSearch />
    </InputRightElement>
  </InputGroup>
</Card>

      <SimpleGrid minChildWidth="xs" spacing="10px">
        {dp_list.map((el, i) => (
          <Card
            paddingInline={5}
            paddingBlock={2}
            cursor={"pointer"}
            onClick={() => navigate("/dp-list/dp-detail", { state: el.id })}
          >
            <DisplayData
              fs={"16px"}
              v_color={"#169e49"}
              fw={"bold"}
              value={el.tradename}
            />
            <Flex justify={"space-between"}>
              <DisplayData title={"GST"} value={el.gst || "NA"} />
              <DisplayData v_color={"#f37022"} value={el.uuid || "NA"} />
            </Flex>
            <DisplayData title={"Personal Mobile"} value={el.mobile1 || "NA"} />
            <DisplayData title={"State"} value={el.state || "NA"}  />
          </Card>
        ))}
      </SimpleGrid>
      <Card
        alignItems={"center"}
        alignSelf={"end"}
        gap={3}
        flexDirection={"row"}
      >
        <FiChevronLeft
          cursor={"pointer"}
          color={page == 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />

        <Flex gap={3}>
          <Text>{initialValue}</Text>-
          <Text>
            {rows * page >= total_dp_count ? total_dp_count : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_dp_count}</Text>
        </Flex>

        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_dp_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>
    </>
  );
};

export default DPList;
